import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "container custom-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "d-none" }, "Back to top", -1)

import AppHeader from "@/components/AppHeader"
import AppFooter from "@/components/AppFooter"
import { useAuthStore, useCustomerStore } from "@/stores"
import { Tooltip } from "bootstrap"
import { defineAsyncComponent, onBeforeMount, onMounted, ref } from "vue"
import { Customer } from "@/types/customer"
import _ from "lodash"
import { router } from "@/router"
import { getLanguageIsoCode, getPageName, trackPageView } from "@/helpers/common"
import { useSystemAndContextStore } from "@/stores/systemAndContext.store"
import ConsentManager from "@/components/ConsentManager.vue"
import { WritableComputedRef } from "vue/dist/vue"
import i18n from "@/internationalisation"
import { switchLocale } from "@/helpers/language"
import {IndexedDbService} from "@/helpers/indexed-db-service";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const RootModal = defineAsyncComponent(() => import("@/components/RootModal.vue"))
const RootGrowl = defineAsyncComponent(() => import("@/components/RootGrowl.vue"))

const systemAndContextStore = useSystemAndContextStore()
const authStore = useAuthStore()
const customerStore = useCustomerStore()
// Set up the Google Tag Manager script
const script = document.createElement("script")
script.async = true

const appButton = ref();
let customer: Customer | null = null;
const dbService = new IndexedDbService("languages", 1, [
  {
    name: "languageList",
    options: {keyPath: "id", autoIncrement: false},
  },
])
const userScroll = () => {
  if (window.scrollY > 800) {
    if (appButton.value && appButton.value.classList) {
      appButton.value.classList.add("showButton")
    }
  } else {
    if (appButton.value && appButton.value.classList) {
      appButton.value.classList.remove("showButton")
    }
  }
}

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" })
}
onMounted(async () => {
  if (_.isEmpty(systemAndContextStore.getCurrentContext)) {
    await systemAndContextStore.fetchCurrentContext()
  }
  if (_.isEmpty(systemAndContextStore.getLanguages)) {
    await systemAndContextStore.fetchLanguages()
  }
  await dbService.connectWithIndexedDb()
  // Iterate through languages and store them in IndexedDB
  const languages = systemAndContextStore.getLanguages
  for (const language of languages) {
    await dbService.set("languageList", { id: language.id, data: JSON.stringify(language) })
  }
  const currentTeamPortalLang = localStorage.getItem("teamportal-lang")
  if (currentTeamPortalLang && currentTeamPortalLang.length <= 2) {
    localStorage.removeItem("teamportal-lang")
  }
  const teamPortalLang = localStorage.getItem("teamportal-lang")
  const teamPortalLangId = localStorage.getItem("teamportal-lang-id")
  if (teamPortalLang && !teamPortalLangId) {
    const languageId = systemAndContextStore.getLanguages.find((item: any) => item?.translationCode?.code.includes(teamPortalLang))?.id || ""
    localStorage.setItem("teamportal-lang-id", languageId)
  }
  if (!teamPortalLang || !teamPortalLangId) {
    const defaultLanguage = systemAndContextStore.getDefaultLanguage
    const defaultIsoCode = getLanguageIsoCode(defaultLanguage)
    if (defaultIsoCode) {
      localStorage.setItem("teamportal-lang", defaultIsoCode)
      ;(i18n.global.locale as WritableComputedRef<string>).value = defaultIsoCode
      switchLocale(defaultIsoCode, defaultLanguage?.id)
    }
  }

  const currentContext = systemAndContextStore.getCurrentContext
  const containerId = _.get(currentContext, "extensions.eecom_gtm_id.eecom_gtm_id", "")
  if (containerId) {
    script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`
    script.async = true
    document.head.appendChild(script)
    router.afterEach((to) => {
      // Set the dynamic page name based on your application's logic
      const pageName = getPageName(to)
      trackPageView(pageName, containerId)
    })
  }
  customer = customerStore.customer
  window.addEventListener("scroll", userScroll)
})
onBeforeMount(() => {
  window.removeEventListener("scroll", userScroll)
})

// Initialize tooltips
new Tooltip(document.body, {
  selector: "[data-bs-toggle='tooltip']",
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        ((_unref(authStore).contextToken && _unref(customerStore).customer) || (_unref(authStore).salesRepContextToken && _unref(authStore).salesRepCustomer))
          ? (_openBlock(), _createBlock(_unref(AppHeader), { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(_component_router_view)
      ]),
      _createVNode(ConsentManager),
      (_unref(authStore).contextToken && _unref(customerStore).customer)
        ? (_openBlock(), _createBlock(_unref(AppFooter), { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_unref(RootModal)),
      _createVNode(_unref(RootGrowl))
    ]),
    _createElementVNode("span", {
      ref_key: "appButton",
      ref: appButton,
      class: "back-to-top",
      href: "#",
      onClick: scrollToTop
    }, [
      _createVNode(_component_vue_feather, {
        stroke: "#ffffff",
        type: "arrow-up"
      }),
      _hoisted_3
    ], 512)
  ], 64))
}
}

})